

// 字段DTO
export interface TFieldDTO {
  id?: number;
  groupId?: number;
  fieldTag?: string;
  fieldName?: string;
  fieldType?: string;
  fieldValue?: string;
  content?: string;
  isEnabled?: number;
  sortNumber?: number;
  createBy?: string;
  createTime?: string;
  updateBy?: string;
  updateTime?: string;
  tenantId?: string;
}

// 字段分组DTO
export interface TFieldGroupDTO {
  id?: number;
  groupName?: string;
  sortNumber?: number;
  isEnabled?: number;
  fields?: TFieldDTO[];
  createBy?: string;
  createTime?: string;
  updateBy?: string;
  updateTime?: string;
  tenantId?: string;
}

// 选项配置
export interface OptionConfig {
  value: number;
  label: string;
}

// 内容配置
export interface ContentConfig {
  options?: OptionConfig[];
  isNewLine?: boolean;
}


export enum FieldKindEnum {
  COMPLEX = 'complex',
  ATOMIC = 'atomic'
}